export default __webpack_public_path__ + "static/media/CancelAppointment.c0d2b798.svg";